import './header.scss';
//react
import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { USER_INFO } from '../../graphql/login';
import { useQuery } from '@apollo/client';
//shared
import IPagesHeader from '../../interfaces/pages-header.interface';
import { useAuth } from '../../../auth/auth';
import { MenuProfile } from '../../../menu-profile/menu-profile';

//material
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';
import { ButtonGroup } from '@mui/material';
import ModalQR from '../modal-qr/modal-qr';

let manager, teacher;
let pages: IPagesHeader[] = [];

const Header = () => {
    
    const { logout } = useAuth();
    const navigate = useNavigate();
    const { data, error } = useQuery(USER_INFO);
    const [modalQR, showQR] = useState<number>(0);

    //Logica para arreglar redirect en raiz
    useEffect(() => {
        if (window.location.pathname === "/" && !window.location.hash) {
            navigate("/branch")
        }
    }, [navigate]);

    if (localStorage.getItem('_token') && window.location.hash === "#/") {
        if (localStorage.getItem('isTeacher') === "true") {
            navigate("/branch")
        } else {
            navigate("/programs")
        }
    }

    if (data) {
        manager = data.user.roles.includes("MANAGER");
        teacher = data.user.roles.includes("TEACHER_ROLE");

        localStorage.setItem('isTeacher', manager);

        pages = [
            { label: "Centros", link: "/branch", show: manager ? true : false, style: (window.location.hash.startsWith('#/branch')) ? 'active' : '' },
            { label: "Programas", link: "/programs", show: teacher ? true : false, style: (window.location.hash.startsWith('#/program')) ? 'active' : '' },
        ];
    };

    if (error) console.log(`Submission error! ${error.message}`);

    const handleCloseUserMenu = (ev: string) => {
        if (ev === 'logout') {
            logout();
        }

    };

    return (
        <React.Fragment>
            <AppBar position="fixed" className='main-container'>
                <div className='container-header'>
                    <Toolbar disableGutters>

                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start'
                        }} className='container-logo'>
                            <div className='logo' onClick={() => navigate(-1)}>
                                <ArrowBackIos />
                                <span>fitpal</span>
                            </div>
                        </Box>

                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end'
                        }} className='w-100 box-logout'>
                            <div className='box-menu'>
                                <ButtonGroup variant="contained">

                                    {pages.map((element, index) => (
                                        <React.Fragment key={index} >
                                            {element.show === true &&
                                                <Button
                                                    size='small'
                                                    key={element.label}
                                                    onClick={() => {
                                                        navigate(element.link);
                                                    }}
                                                    sx={{ my: 2, color: 'black', display: 'block' }}
                                                    className={element.style}
                                                >
                                                    <h4>{element.label}</h4>
                                                </Button>
                                            }
                                        </React.Fragment>
                                    ))
                                    }
                                </ButtonGroup>
                            </div>

                            <Box>
                                <div onClick={() => handleCloseUserMenu('logout')} className="btn-logout">
                                    <Button >
                                        <h4>Cerrar sesión</h4>
                                        <LogoutIcon />
                                    </Button>
                                </div>
                            </Box>
                        </Box>

                        <Box className='box-info-profile'>
                            <MenuProfile showQR={(branchId: number) => showQR(branchId)}></MenuProfile>

                            <ModalQR modalQR={modalQR ? true : false} branchId={modalQR}></ModalQR>
                        </Box>
                    </Toolbar>
                </div>
            </AppBar>
            <Outlet />
        </React.Fragment>
    );
};

export default Header;